import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/profile/leo-giesen.webp'


const _hoisted_1 = { class: "fullwidth" }
const _hoisted_2 = { class: "text-h3 font-weight-light" }
const _hoisted_3 = { class: "text-subtitle-1" }
const _hoisted_4 = {
  width: "100vw",
  class: "d-flex justify-center w-100 mx-auto"
}
const _hoisted_5 = { class: "animated-gradient-box in" }
const _hoisted_6 = ["innerHTML"]

import HeroBackgroundGradientGroup from '@/assets/background/HeroBackgroundGradientGroup.vue';
import ScrollHero from '@/components/scroll/ScrollHero.vue';
import { computed } from 'vue';
import { useTheme } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const theme = useTheme()
const currentTheme = computed(() => theme.global.name.value)
const isDarkTheme = computed(() => currentTheme.value === 'dark')
const gradientBtn = computed(() => ({
  backgroundImage: `
    linear-gradient(to right,
      ${theme.current.value.colors.heroGradientBackgroundLeft} 0%,
      ${theme.current.value.colors.heroGradientBackgroundRight} 50%,
      ${theme.current.value.colors.heroGradientBackgroundLeft} 100%)`,
  backgroundSize: "200% auto",
  transition: "0.5s",
  color: "white", // icon color
}))
const colors = computed(() => theme.current.value.colors)

const gradientTitle = computed(() => ({
  background: `-webkit-linear-gradient(120deg, ${colors.value.secondary}, ${colors.value.primary})`,
  "background-clip": "text",
  "-webkit-background-clip": "text",
  "-webkit-text-fill-color": "transparent"
}))

const skillCardGroup = [
  {
    title: 'mlbiTitle',
    textSrc: 'mlbi',
    backgroundImage: require('@/assets/home/machine_learning.webp'),
    icon: 'language-python',
    aria: 'Machine Learning and Artificial Intelligence'
  },
  {
    title: 'dataScienceTitle',
    textSrc: 'dataScienceText',
    backgroundImage: require('@/assets/home/data-science.webp'),
    icon: 'database-search',
    aria: 'Data Science and Data Analysis'
  },
  {
    title: 'feTitle',
    textSrc: 'frontend',
    backgroundImage: require('@/assets/home/web_dev.webp'),
    icon: 'vuejs',
    aria: 'Front-end Web Development Vue.js'
  },
  {
    title: 'beTitle',
    textSrc: 'backend',
    backgroundImage: require('@/assets/home/backend.webp'),
    icon: 'database',
    aria: 'API and backend Web Development'
  },
  {
    title: 'itArchitectureTitle',
    textSrc: 'itArchitecture',
    backgroundImage: require('@/assets/home/it-architecture.webp'),
    icon: 'lan-connect',
    aria: 'It Architecture'
  },
  {
    title: 'officeTitle',
    textSrc: 'office',
    backgroundImage: require('@/assets/home/microsoft_office_365.webp'),
    icon: 'microsoft-office',
    aria: 'Microsoft Office and Microsoft 365'
  },
  {
    title: 'sdevTitle',
    textSrc: 'softwareDev',
    backgroundImage: require('@/assets/home/software_development.webp'),
    icon: 'language-java',
    aria: 'Software Development'
  },
  {
    title: 'otherTitle',
    textSrc: 'other',
    backgroundImage: require('@/assets/home/desk.webp'),
    icon: 'star',
    aria: 'Other'
  }
]

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(HeroBackgroundGradientGroup, { class: "position-absolute" }),
        _createVNode(_component_v_container, { class: "text-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "pa-md-12 pb-md-0 align-center justify-center",
              style: {"min-height":"100vh"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "text-white transparent-background",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("home.homeHero.title")), 1),
                        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("home.homeHero.subtitle")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(ScrollHero)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          alt: "Leo Giesen Profil",
                          src: _imports_0
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_component_v_container, { id: "scroll" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h5 text-center text-wrap" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("home.homeIntro.title")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "d-flex flex-column align-center text-justify" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("home.homeIntro.text")) + " ", 1),
                          _createVNode(_component_v_btn, {
                            class: "ma-8 mt-12",
                            rounded: "",
                            style: _normalizeStyle(gradientBtn.value),
                            href: `/CV/CV-Leo-Giesen-${_ctx.$i18n.locale.toUpperCase()}.pdf`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { class: "me-2" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createTextVNode("mdi-account-tie")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("home.homeIntro.downloadCV")), 1)
                            ]),
                            _: 1
                          }, 8, ["style", "href"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("article", null, [
      _createElementVNode("section", null, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-h3 mb-6" }, "Skills", -1)),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "d-flex flex-wrap justify-space-between" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skillCardGroup, (card) => {
                  return _createVNode(_component_v_col, {
                    key: card.title,
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        height: "100%",
                        "max-width": "94vw"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_img, {
                              class: "d-flex align-center justify-center text-white fill-height",
                              cover: "",
                              "max-height": "200px",
                              src: card.backgroundImage,
                              alt: card.aria,
                              gradient: isDarkTheme.value ? 'rgba(0,0,0,.6), rgba(0,0,0,.9)' : 'rgba(255,255,255,.6), rgba(255,255,255,.9)'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "text-center" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("pre", null, [
                                      _cache[1] || (_cache[1] = _createTextVNode("                        ")),
                                      _createElementVNode("h2", {
                                        class: "font-weight-bold text-h4 break text",
                                        style: _normalizeStyle([gradientTitle.value, { wordBreak: 'break-word', whiteSpace: 'normal' }]),
                                        width: "94vw",
                                        "max-width": "94vw",
                                        "min-height": "400"
                                      }, "\n                          " + _toDisplayString(_ctx.$t('home.skills.' + card.title)) + " ", 5),
                                      _cache[2] || (_cache[2] = _createTextVNode("\n                      "))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["src", "alt", "gradient"])
                          ]),
                          _createVNode(_component_v_col, { class: "seperatorIcon py-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                elevation: "15",
                                icon: "",
                                color: "background"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { color: "primary" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-" + _toDisplayString(card.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", {
                                class: "text-body-1 text-justify my-0 py-0",
                                innerHTML: _ctx.$t('home.skills.' + card.textSrc)
                              }, null, 8, _hoisted_6)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})